import React from "react";
import { MASKS } from "./masklist";

const CovidMasks = () => {
  const generateMasks = () => {
    return MASKS.map(mask => {
      return (
        <div className="maskItem" key={mask.colour}>
          <img className="maskSwatch" src={mask.swatchImg} alt={mask.colour} />
          <div className="maskDescription">
            <p className="swatchTitle">{mask.colour}</p>
            <a
              className="maskButton"
              href={mask.mailLink}
              target="_blank"
              rel="noopener noreferrer"
              role="button"
            >
              {mask.displayButton ? "BUY - $20" : "SOLD OUT!"}
            </a>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="centerStyling fadeInFast">
      <div className="header">
        <h2>Covid Masks</h2>
        <p>
          Let's leave the medical masks for the healthcare heroes. Made with
          repurposed materials, each mask features a soft lining and an opening
          for a filter insert. All masks are available in medium, large, and
          kids sizes.
        </p>
        <p>
          Click BUY to email your order. Please include the quantity and sizes.
          All prices listed in Canadian, and include tax and shipping. Canada
          only.
        </p>
      </div>
      <div className="maskRow">{generateMasks()}</div>
    </div>
  );
};

export default CovidMasks;
